import { ButtonGroup } from '@material-ui/core';
import React, { Component, Fragment } from 'react';
import { InputGroup } from 'reactstrap';
import { ArcaHttpClientList } from '../../../code/ArcaHttpClientList';
import { ArcaLink } from './ArcaLink';

export class InputLookupButtons extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            selectedValue: this.props.value,
            status: null,
            mandatory: this.props.mandatory,
            fieldValid: null,
            dropdownOpen: false,
            label: this.props.label ?? this.props.fieldname,
            description: this.props.description ?? null,
            items: [],
            prependWidth: this.props.prependWidth ?? '160px',
            showHelp: false,
            inline: this.props.inline ?? false,
            canClear: this.props.canClear ?? false
        };
    }

    async componentDidMount() {
        await ArcaHttpClientList.GetWithCodesAsync(this.props.listName, this.receivedList.bind(this))
    }

    receivedList(list) {
        this.setState({ items: list });
    }

    toggleDropDown() {
        this.setState({ dropdownOpen: !this.state.dropdownOpen });
    }

    static getDerivedStateFromProps(props, state) {
        if (props.value !== state.value) {
            return {
                value: props.value
            };
        }

        return null;
    }

    render() {
        let { showHelp, selectedValue, label } = this.state;

        return (

            <Fragment>
                <div className='centerText'>
                    <h3>{label}</h3>
                    <ButtonGroup className='buttonGroup'>
                        <InputGroup>
                            <div className='centerText'>
                                {this.state.items.map((item) =>
                                    <ArcaLink
                                        text={item.Value}
                                        colour={(item.Value === selectedValue) ? 'primary' : 'secondary'}
                                        key={Math.random()}
                                        onClick={this.handleUserInput.bind(this, item)} />
                                )}
                            </div>
                        </InputGroup>
                        {this.props.description && showHelp ?
                            <div className='inputFieldDescription'>
                                {this.props.description}
                            </div>
                            : null}
                    </ButtonGroup>
                </div>
            </Fragment>
        );
    }

    handleUserInput(item) {

        var valid = true;
        this.props.onUpdate(item?.Value, true, this.props.fieldname, item?.Code);

        this.setState({
            value: item ? item.Value : '',
            fieldValid: valid,
            selectedValue: item?.Value
        });
    }
}
